import { useAppStore } from '@/stores/app'
import { log } from '@/utils/logger'

// Get platform from URL params
const urlParams = new URLSearchParams(typeof window !== 'undefined' ? window?.location?.search : '')
const platform = urlParams.get('platform')

// Polyfill message handler for browser testing
function handlePolyfillMessage(action, data, callbackId) {
	// Simulate app resume/pause events for browser
	if (!document.hasVisibilityChangeListener) {
		document.addEventListener('visibilitychange', (event) => {
			console.warn('visibilitychange', document.visibilityState, event)
			if (document.visibilityState == 'visible') {
				window.dispatchEvent(new Event('resume'))
			} else {
				window.dispatchEvent(new Event('pause'))
			}
		})
		document.hasVisibilityChangeListener = true
	}

	// Handle polyfill actions for browser testing
	setTimeout(() => {
		try {
			if (action == 'getPrivacyDashboardUrl') {
				const url = 'https://privacy.pinch.services/dashboard/?key=eyAgICAiaXNzIjogImNvbS5rb2dlbnRhLktldHRsZVNhbXBsZSIsCiAgICAiYXVkIjogIjZhOTUxYTlmLTg2NmYtNDU1Yi1hNWVjLTVlNzRlZDE4NzVkNSIsCiAgICAidGltZXN0YW1wIjogMTc0Nzk4ODg1MTgzNCwKICAgICJjb25zZW50cyI6IFsxMDAxLDEwMDIsMTAwMywxMDA0XSwKICAgICJwZXJtaXNzaW9ucyI6IFsxMDMsMzAxLDQwMSw1MDFdLAogICAgInNlbnNvclN0YXRlcyI6IFsyMDEsMTAxXSwKICAgICJtb2R1bGVzIjogWyJhY3Rpdml0eSIsImJsdWV0b290aCIsImxvY2F0aW9uIl0sCiAgICAiYm9vdFRpbWUiOiAxNzQ2OTAzMDAyNzg0LAogICAgImRldmljZU1vZGVsIjogImlQaG9uZTE2LDIiLAoiZGVzaXJlZEFjY3VyYWN5IjogLTEuMCwKImRpc3RhbmNlRmlsdGVyIjogLTEuMCwKImJhdHRlcnlMZXZlbCI6IDAuOCwKInN0YXRlQ2hhbmdlZCI6IDE3NDc3NzY3NzAyMDMsCiJjb25maWdVcGRhdGVkIjogMTc0Nzk0NDQ5MjUzMX0=.16263086def2d0a1eb289ef932e06944cc70bcbf6522c8e777d7a6716d3d9e24'
				window[callbackId](url)
				return
			}

			if (action == 'openUrl') {
				const url = data.url
				window.open(url, '_blank')
				window[callbackId]('success')
				console.log('kettle.openUrl', url)
				return
			}

			// Handle storage operations
			if (action == 'set') {
				const key = data.key
				let value = data.value
				if (typeof value !== 'string') value = JSON.stringify(value)
				localStorage.setItem(key, value)
				window[callbackId]('true')
			} else if (action == 'get') {
				const key = data.key
				const value = localStorage.getItem(key) || ''
				const safeValue = value.replace(/\n/g, ' ')
				window[callbackId](safeValue)
			} else if (action == 'remove') {
				const key = data.key
				localStorage.removeItem(key)
				window[callbackId]('true')
			}

			const permissionType = data?.permissionType
			const storedPermission = localStorage.getItem(permissionType) || 'not_determined'

			if (action == 'getConsents') {
				let consents = localStorage.getItem('consents')
				if (consents) consents = JSON.parse(consents)
				else consents = []
				window[callbackId](JSON.stringify(consents))
			}

			if (action == 'grantConsents') {
				let existingConsents = localStorage.getItem('consents')
				if (existingConsents) existingConsents = JSON.parse(existingConsents)
				else existingConsents = []
				const newConsents = data.consents
				if (newConsents) {
					newConsents.forEach((consent) => {
						if (!existingConsents.includes(consent)) {
							existingConsents.push(consent)
						}
					})
				}
				localStorage.setItem('consents', JSON.stringify(existingConsents))
				window[callbackId](JSON.stringify(existingConsents))
			}

			if (action == 'revokeConsents') {
				let existingConsents = localStorage.getItem('consents')
				if (existingConsents) existingConsents = JSON.parse(existingConsents)
				else existingConsents = []
				const newConsents = data.consents
				if (newConsents) {
					newConsents.forEach((consent) => {
						if (existingConsents.includes(consent)) {
							existingConsents = existingConsents.filter((c) => c !== consent)
						}
					})
				}
				localStorage.setItem('consents', JSON.stringify(existingConsents))
				window[callbackId](JSON.stringify(existingConsents))
			}

			if (action == 'checkPermission') {
				window[callbackId](storedPermission)
			}

			if (action == 'requestPermission') {
				const permissionQuestions = {}
				permissionQuestions[window.kettle.permissions.LOCATION_WHENINUSE] = 'Vil du godkjenne tilgangen til stedstjenester?'
				permissionQuestions[window.kettle.permissions.LOCATION_ALWAYS] = 'Vil du godkjenne tilgangen dine posisjoner når du reiser?'
				permissionQuestions[window.kettle.permissions.NOTIFICATION] = 'Vil du godkjenne tilgangen til varslinger?'
				permissionQuestions[window.kettle.permissions.BLUETOOTH] = 'Vil du godkjenne tilgangen til Bluetooth?'
				permissionQuestions[window.kettle.permissions.MOTION] = 'Vil du godkjenne tilgang til dine bevegelser?'

				if (storedPermission == 'not_determined') {
					const appStore = useAppStore()
					appStore.showConfirm(permissionQuestions[permissionType]).then((isGranted) => {
						if (isGranted) {
							localStorage.setItem(permissionType, 'granted')
							if (window[callbackId]) {
								window[callbackId]('granted')
								delete window[callbackId]
							}
						} else {
							localStorage.setItem(permissionType, 'denied')
							if (window[callbackId]) {
								window[callbackId]('denied')
								delete window[callbackId]
							}
						}
					})
					// Don't clean up for async permission requests
					return
				} else {
					window[callbackId](storedPermission)
				}
			}

			// Clean up callback
			setTimeout(() => {
				if (window[callbackId]) {
					delete window[callbackId]
				}
			}, 1000)
		} catch (error) {
			console.error('Error in polyfill message handler:', error)
			if (window[callbackId]) {
				window[callbackId]('error')
				delete window[callbackId]
			}
		}
	}, 10)
}

function expandKettle() {
	if (typeof window.kettle.getLocation === 'undefined') {
		// Earlier version of SDK does not support getLocation so using web interface
		window.kettle.getLocation = function () {
			return new Promise((resolve) => {
				const defaultLocation = { latitude: 59.9139, longitude: 10.7522, zoom: 8 }
				if (!navigator.geolocation) {
					console.error('Geolocation not supported, using default location', defaultLocation)
					return resolve(defaultLocation)
				}
				navigator.geolocation.getCurrentPosition(
					(position) =>
						resolve({
							timestamp: new Date().getTime(),
							latitude: position.coords.latitude,
							longitude: position.coords.longitude,
							hacc: position.coords.accuracy,
							zoom: 12,
						}),
					(error) => {
						console.error('Geolocation error:', error)
						return resolve(defaultLocation)
					},
				)
			})
		}
	}
	if (typeof window.kettle.getSafe === 'undefined') {
		window.kettle.getSafe = async function (key, defaultValue = '') {
			try {
				const value = await window.kettle.get(key)
				return value !== undefined && value != null ? value : defaultValue
			} catch (error) {
				console.error('Error getting safe value:', error)
				return defaultValue
			}
		}
	}
}

// Browser polyfill kettle object creation
function addBrowserKettlePolyfill() {
	console.log('Creating kettle polyfill for platform:', platform || 'browser')
	window.kettle = {
		sendMessage: function (action, data) {
			return new Promise((resolve) => {
				const callbackId = 'cb_' + Math.random().toString(36).substr(2, 9)
				window[callbackId] = resolve
				handlePolyfillMessage(action, data, callbackId)
			})
		},
		decompressData: async function (compressedData, parse = false) {
			const compressedArray = Uint8Array.from(atob(compressedData), (c) => c.charCodeAt(0))
			const decompressedStream = new Response(
				new ReadableStream({
					start(controller) {
						controller.enqueue(compressedArray)
						controller.close()
					},
				}).pipeThrough(new DecompressionStream('deflate-raw')),
			).body
			const decompressedText = await new Response(decompressedStream).text()
			return parse ? JSON.parse(decompressedText) : decompressedText
		},
		ready: function () {
			return this.sendMessage('ready')
		},
		update: function () {
			return this.sendMessage('update')
		},
		mounted: function () {
			return this.sendMessage('mounted')
		},
		set: function (key, value) {
			log('Kettle.set:' + key, value).purple()
			return this.sendMessage('set', { key: key, value: value })
		},
		get: function (key) {
			return this.sendMessage('get', { key: key })
		},
		remove: function (key) {
			return this.sendMessage('remove', { key: key })
		},
		notification: function (payload) {
			return this.sendMessage('notification', payload)
		},
		storeMetadata: function (key, value) {
			if (typeof value !== 'string') value = JSON.stringify(value)
			return this.sendMessage('storeMetadata', { key: key, value: value })
		},
		getMetadata: function (key) {
			return this.sendMessage('getMetadata', { key: key }).then((result) => JSON.parse(result))
		},
		sendMetadata: function (type, json) {
			return this.sendMessage('sendMetadata', { type: type, json: json })
		},
		sendCustomJson: function (type, json) {
			return this.sendMessage('sendCustomJson', { type: type, json: json })
		},
		sendApplicationEvent: function (name, json) {
			return this.sendMessage('sendApplicationEvent', { name: name, json: json })
		},
		openUrl: function (url) {
			return this.sendMessage('openUrl', { url: url })
		},
		getCustomData: function (type, key, fromDate, toDate) {
			if (typeof fromDate !== 'string') fromDate = fromDate.toISOString()
			if (typeof toDate !== 'string') toDate = toDate.toISOString()
			return this.sendMessage('getCustomData', { type: type, key: key, fromDate: fromDate, toDate: toDate })
		},
		getPrivacyDashboardUrl: function () {
			return this.sendMessage('getPrivacyDashboardUrl')
		},
		storeCustomData: function (type, jsonData, startDate, endDate, upload = false) {
			if (typeof startDate !== 'string') startDate = startDate.toISOString()
			if (typeof endDate !== 'string') endDate = endDate.toISOString()
			return this.sendMessage('storeCustomData', { type: type, data: jsonData, startDate: startDate, endDate: endDate, upload: upload })
		},
		sendCustomData: function (type, data, startDate, endDate) {
			if (typeof data !== 'string') data = JSON.stringify(data)
			if (typeof startDate !== 'string') startDate = startDate.toISOString()
			if (typeof endDate !== 'string') endDate = endDate.toISOString()
			return this.sendMessage('sendCustomData', { type: type, data: data, startDate: startDate, endDate: endDate })
		},
		getData: function (dataRequests, options = {}) {
			return this.sendMessage('getData', {
				dataRequests: dataRequests.map((request) => ({
					type: request.type,
					key: request.key,
					startDate: request.startDate,
					endDate: request.endDate,
				})),
				compress: options.compress || false,
			}).then(async (result) => {
				if (options.compress) {
					result = await this.decompressData(result, options.parse)
				}
				return options.parse !== false ? JSON.parse(result) : result
			})
		},
		checkPermission: function (permissionType) {
			return this.sendMessage('checkPermission', { permissionType: permissionType })
		},
		requestPermission: function (permissionType) {
			return this.sendMessage('requestPermission', { permissionType: permissionType })
		},
		startModules: function (modules) {
			console.warn('Kettle: startModules', modules)
		},
		stopModules: function (modules) {
			console.warn('Kettle: stopModules', modules)
		},
		grantConsents: function (consents) {
			return this.sendMessage('grantConsents', { consents: consents })
		},
		revokeConsents: function (consents) {
			return this.sendMessage('revokeConsents', { consents: consents })
		},
		getConsents: function () {
			return this.sendMessage('getConsents').then((result) => JSON.parse(result))
		},
		permissions: {
			LOCATION_WHENINUSE: 'location_wheninuse',
			LOCATION_ALWAYS: 'location_always',
			LOCATION: 'location',
			NOTIFICATION: 'notification',
			BLUETOOTH: 'bluetooth',
			MOTION: 'motion',
		},
	}
	// Expand kettle with additional methods
	expandKettle()
}

// Android-specific kettle modifications
function applyAndroidKettleModifications() {
	console.warn('Adding kettle changes for android')

	window.kettle.requestPermission = function (permissionType) {
		return window.kettle.sendMessage('requestPermissionInternal', permissionType)
	}

	window.kettle.sendMessage = function (action, data) {
		return new Promise((resolve) => {
			const callbackId = 'cb_' + Math.random().toString(36).substr(2, 9)
			kettle[action](data, callbackId)
			window[callbackId] = resolve
		})
	}

	window.kettle.remove = function (key) {
		return window.kettle.sendMessage('removeInternal', key)
	}

	window.kettle.get = function (key) {
		return window.kettle.sendMessage('getInternal', key)
	}

	window.kettle.set = function (key, value) {
		return window.kettle.sendMessage('setInternal', JSON.stringify({ key: key, value: value }))
	}

	window.kettle.startModules = function (modules) {
		return window.kettle.sendMessage('startModulesInternal', JSON.stringify(modules))
	}

	window.kettle.stopModules = function (modules) {
		return window.kettle.sendMessage('stopModulesInternal', JSON.stringify(modules))
	}

	window.kettle.grantConsents = function (consents) {
		return window.kettle.sendMessage('grantConsentsInternal', JSON.stringify(consents))
	}

	window.kettle.revokeConsents = function (consents) {
		return window.kettle.sendMessage('revokeConsentsInternal', JSON.stringify(consents))
	}

	window.kettle.getLocation = function () {
		return window.kettle.sendMessage('getLocationInternal', '')
	}

	window.kettle.getConsents = function () {
		return window.kettle.sendMessage('getConsentsInternal', '')
	}

	window.kettle.getData = function (dataRequests) {
		const dataRequestsString = JSON.stringify(dataRequests)
		return window.kettle.sendMessage('fetchDataFromJs', dataRequestsString).then(async (result) => {
			console.warn('fetchDataFromJs resolved')
			return atob(result)
		})
	}

	// Add kettle.permissions if not already defined
	if (typeof window.kettle.permissions === 'undefined') {
		window.kettle.permissions = {
			LOCATION_WHENINUSE: 'location_wheninuse',
			LOCATION_ALWAYS: 'location_always',
			LOCATION: 'location',
			NOTIFICATION: 'notification',
			BLUETOOTH: 'bluetooth',
			MOTION: 'motion',
		}
	}
	// Expand kettle with additional methods
	expandKettle()
}

// Only create the polyfill kettle object if NOT on iOS or Android platforms
if (platform !== 'ios' && platform !== 'android' && typeof window.kettle === 'undefined') {
	addBrowserKettlePolyfill()
} else {
	if (platform === 'android') {
		if (typeof window.kettle !== 'undefined') {
			applyAndroidKettleModifications()
		} else {
			const error = new Error('Android platform detected but kettle object is not available!')
			console.error(error.message)
			throw error
		}
	}
}

// Simple promise that resolves when kettle is ready
window.kettleReadyPromise = new Promise((resolve, reject) => {
	if (platform == 'ios') {
		// For iOS, kettle is injected after page load, so we need to wait
		let resolved = false
		let timestamp = Date.now()

		// Set a 5-second timeout as fallback
		const timeout = setTimeout(() => {
			if (!resolved) {
				resolved = true
				const error = new Error('Timeout: Kettle not available after 5 seconds on iOS platform')
				console.error(error.message)
				reject(error)
				throw error
			}
		}, 5000)

		const checkKettle = () => {
			var timePassed = Date.now() - timestamp
			if (!resolved && typeof window.kettle !== 'undefined') {
				resolved = true
				clearTimeout(timeout)
				console.log('Kettle available for iOS platform after' + timePassed + 'ms')
				expandKettle()
				resolve()
			} else if (!resolved) {
				setTimeout(checkKettle, 50)
			}
		}
		// Start checking for kettle availability
		checkKettle()
	} else {
		if (typeof window.kettle !== 'undefined') {
			console.log('Kettle immediately available for platform:', platform || 'browser')
			resolve()
		} else {
			const error = new Error(`Kettle not available for ${platform || 'browser'} platform`)
			console.error(error.message)
			reject(error)
			throw error
		}
		return
	}
})

// Utility function for components to wait for kettle
window.waitForKettle = () => window.kettleReadyPromise

export const kettle = window.kettle
